import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { format, formatDistance } from 'date-fns';
import { enGB } from 'date-fns/locale/en-GB';
import { fr } from 'date-fns/locale/fr';
import type { Locale } from 'date-fns';

// Langues réellement supportées par l'app (importer tout `date-fns/locale` alourdit le bundle d'environ 1 Mo).
// Ajouter ici la locale date-fns correspondante quand une traduction est ajoutée.
const dateLocales: Record<string, Locale> = { fr, enGB };

export function useDateLocale() {
  const { t } = useTranslation();
  const [locale] = t('translation:locale').split('-');
  return dateLocales[locale] || enGB;
}

export function useDateFormat() {
  const locale = useDateLocale();
  return useCallback(
    (date: Date | string, pattern: string): string =>
      format(date, pattern, { locale }),
    [locale],
  );
}

export function useDateFormatDistance() {
  const locale = useDateLocale();
  return useCallback(
    (date: Date | string, pattern: string): string =>
      formatDistance(date, pattern, { locale }),
    [locale],
  );
}

export default useDateFormat;
